import { Suspense } from 'react';

import { HOME_DOCUMENT_PATH } from '#constants/home-document';

import {
  DocumentByPathRoute,
  DocumentByPathRouteFallback,
} from './document-by-path-route';

export function HomeDocumentRoute() {
  return (
    <Suspense fallback={<DocumentByPathRouteFallback />}>
      <DocumentByPathRoute documentPath={HOME_DOCUMENT_PATH} />
    </Suspense>
  );
}
